const angular = require('angular');
const app = angular.module('learn-services');
app.factory('Access', ['AnalyticsProvider', 'Storage', function(AnalyticsProvider, Storage) {
    var self = this;
    /**
     * Access control object
     */
    self.access = {
      profile: null,
      profileChecked: false,
      profileRecheck: null,
      role: 'user',
      authtoken: null,
      user: {},
      sync: false,
      setAuthtoken: function(token) {
        if (!token) {
          throw new Exception('Invalid token, cannot be null');
        }
        if (!token.user) {
          throw new Exception('Invalid token, token.user cannot be null');
        }
        if (!token.authtoken) {
          throw new Exception('Invalid token, token.authtoken cannot be null');
        }
        self.access.authtoken = token;
        self.access.role = token.user && token.user.role || 'user';
        self.access.user = token.user;
        self.access.setProfile((token.user && token.user.access_profile) || null);
        AnalyticsProvider.setUserInfo(self.access.authtoken);
        self.access.sync = true;
      },
      getAuthtoken: function() {
        if (self.access.authtoken) {
          return self.access.authtoken;
        } else {
          self.access.authtoken = Storage.get('authtoken');
          if (self.access.authtoken) {
            self.access.setAuthtoken(self.access.authtoken);
          }
        }
      },
      removeAuthtoken: function() {
        self.access.profile = null;
        self.access.profileChecked = false;
        self.access.profileCheckedDate = null;
        self.access.role = 'user';
        self.access.authtoken = null;
        self.access.user = {};
      },
      setProfile: function(profile) {
        self.access.profile = profile || null;
        self.access.profileChecked = true;
        // recheck in 30 minutes
        self.access.profileRecheck = new Date(new Date().getTime() + 30 * 60000).valueOf();
      }
    };
    return self.access;
  }]);